module.exports = __webpack_public_path__ + "img/home-3-hero-bg-effect.758bb29c.png";